import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"

function AnalisisArticulosPedidos() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${import.meta.env.VITE_URL_INVENTARIOS}`;
  const URL_SEGUIMIENTOS = `${import.meta.env.VITE_URL_SEGUIMIENTOS}`;
  const URL_ARTICULOS = import.meta.env.VITE_URL_ARTICULOS;
  const URL_ARTICULOS_PEDIDO = import.meta.env.VITE_URL_ARTICULOS_PEDIDO;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");




  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");



    //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50


  useEffect(() => {
       axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
  
  }, []);

  function BuscaArticulo(event) {
    setSelectedArticulo(event.target.value)
    setComments([])


  // Jala Movimientos
  axios
  .get(`${URL_ARTICULOS_PEDIDO}Articulo/${event.target.value}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allMovs = response.data
    setComments(allMovs);
  })
  .catch((err) => {
    console.log(err);
  })
  }




  const headers = [
    { name: "Pedido", field: "pedido", sortable: false },
    { name: "Cliente", field: "cliente", sortable: false },
    { name: "Almacen", field: "areaSurtido", sortable: false },
    { name: "Activo", field: "activo", sortable: false },
    { name: "Apartado", field: "autorizadoApartado", sortable: false },
    { name: "Aut Surtir", field: "autorizadoSurtido", sortable: false },
    { name: "Cantidad", field: "cantidad", sortable: false },
    { name: "Surtido", field: "surtido", sortable: false },
    { name: "Pend Surtir", field: "pendiente_surtir", sortable: false },
];



  const commentsData = useMemo(() => {
    let computedComments = comments
  
    if (search) {
        computedComments = computedComments.filter(
            comment =>
                comment.pedido.toLowerCase().includes(search.toLowerCase()) ||
                comment.tipoMov.toLowerCase().includes(search.toLowerCase()) 
        );
    }


    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
        const reversed = sorting.order === "asc" ? 1 : -1;
        computedComments = computedComments.sort(
            (a, b) =>
                reversed * a[sorting.field].localeCompare(b[sorting.field])
        );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting]);




let totalCantidad = 0
let totalSurtido = 0
let totalPendiente = 0

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
         
          </Row>
         
      
          <h3 align="center">Analisis Articulos Pedidos</h3>
          <div className="row">
          <div className="col-md-2">
            <Label>Codigo QR</Label>
          </div>
          <div className="col-md-2">
            <Label>Codigo</Label>
          </div>
          <div className="col-md-2">
            <Label>Articulo</Label>
          </div>
          </div>
          <div className="row">
          <div className="col-md-2">
                        <Input
                            bsSize="sm"
                            type="text"
                            value={selectedArticulo}
                            onChange={(e) => {
                              BuscaArticulo(e)
                              setCurrentPage(1)
                            }}
                          >
                          </Input>
                          </div>
                        <div className="col-md-2">
                        <Input
                            bsSize="sm"
                            type="select"
                            value={selectedArticulo}
                            onChange={(e) => {
                              BuscaArticulo(e)
                              setCurrentPage(1)
                            }}
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                              .map((a) => {
                                return <option value={a._id}>{a.codigo} </option>;
                              })}
                          </Input>
                          </div>

                          <div className="col-md-2">
                        <Input
                            bsSize="sm"
                            type="select"
                            value={selectedArticulo}
                            onChange={(e) => {
                              BuscaArticulo(e)
                              setCurrentPage(1)
                            }}
                          >
                            <option value="">Selecciona</option>
                            {articulos
                              .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                              .map((a) => {
                                return <option value={a._id}>{a.codigo} </option>;
                              })}
                          </Input>
                          </div>
                         
                        {/* <div className="col-md-6 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div> */}
                        
                    </div>
                    <br />





                    {/* Tabla Movimientos */}
                     <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />

          <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                      
            <tbody>
              {commentsData.map((a) => {
                if(a.is_active === "Si"){
                totalCantidad = totalCantidad + parseFloat(a.cantidad);
                totalSurtido = totalSurtido + parseFloat(a.surtido);
                totalPendiente = totalPendiente + parseFloat(a.pendiente_surtir);
                  return (
                    <tr>
                      <td>{a.pedidos[0].idPedido}</td>
                      <td>{a.pedidos[0].clientes[0].nombre_comercial}</td>
                      <td>{a.pedidos[0].areas[0].name}</td>
                      <td>{a.is_active}</td>
                      <td>{a.autorizadoApartado}</td>
                      <td>{a.autorizadoSurtido}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.surtido)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.pendiente_surtir)}</td>
                    </tr>
                  )}
              })}


              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTALES</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalCantidad)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalSurtido)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalPendiente)}
                </td>


              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
        </div>
      ) : undefined}


      {loader}
    </>
  );
}

export default AnalisisArticulosPedidos;
